import { ReactNode } from "react"

import MUIDialog, {
  DialogProps as MUIDialogProps,
} from "@material-ui/core/Dialog"

export type DialogProps = {
  open: boolean
  onClose: () => void
  id: string

  className?: string
  children: ReactNode
  //
} & Omit<MUIDialogProps, "open" | "onClose" | "id" | "className" | "childen">

export function Dialog(props: DialogProps) {
  const {
    open,
    onClose,
    id,
    children,
    className,
    maxWidth = "sm",
    ...restMuiProps
  } = props
  return (
    <MUIDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      aria-labelledby={id}
      className={className}
      {...restMuiProps}
    >
      {children}
    </MUIDialog>
  )
}
